/// <amd-module name="Feed/CreateFeed/Redux/ZeroFeeds/ZeroFeedsContracts" />

export interface IZeroFeedsState {
    isUserAnonymousOrPublic: boolean;
    imagePath: string;
}
